<template>
  <!-- eslint-disable max-len,vue/max-len -->
  <school-page
    banner-title="семейное обучение в&nbsp;школьном университете"
    banner-subtitle="учитесь из&nbsp;любой точки мира онлайн на&nbsp;платформе и&nbsp;получите московский аттестат государственного образца"
  />
</template>

<script>
import SchoolPage from '../index.vue';

export default {
  name: 'SchoolSemeinoePage',
  components: {
    SchoolPage,
  },
  layout: 'DefaultLayoutV2',
};
</script>

<style scoped lang="scss">

::v-deep(h1.main-banner__subtitle) {
  margin-top: calc(var(--scale) * 10);
  margin-bottom: calc(var(--scale) * 32);
  font-size: calc(var(--scale) * 112);

  @include media-down($size-tablet) {
    margin-top: calc(var(--scale) * 8);
    max-width: calc(var(--scale) * 346);
    margin-bottom: calc(var(--scale) * 12);
    font-size: calc(var(--scale) * 56);
  }

  @include media-down($size-mobile) {
    margin-top: 0;
  }
}

::v-deep(h2.main-banner__title) {
  max-width: calc(var(--scale) * 715);

  @include media-down($size-tablet) {
    max-width: calc(var(--scale) * 346);
  }
}

::v-deep(div.main-banner) {
  .main-banner__title {
    @include media-up($size-tablet) {
      font-size: calc(var(--scale) * 112);
      line-height: 75%;
    }
  }

  @include media-down($size-mobile) {
    padding-top: calc(var(--scale) * 16);
    background-image: url("/v2/school-new/other-pages/banner-bg-mob.webp");
  }
}

</style>
